import { createElement as rc } from 'react';
import { Caret, Pressable } from 'lib_ui-primitives';

export default function ArrowButton(props) {
    const { direction = 'right' } = props;
    return rc(Pressable, props, rc(Caret, { direction }));
}
